import { Plus, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Input } from "@/components/ui/input";

export default function Replacements({ rows, setRows, custom, setCustom, ai }) {
  const upd = (i, patch) => setRows(rows.map((r, j) => (j === i ? { ...r, ...patch } : r)));
  return (
    <div data-testid="dup-replacements">
      <p className="text-sm font-semibold text-slate-900">Dati del cliente originale trovati nel sito</p>
      <p className="mt-0.5 text-xs text-slate-500">
        {ai ? "L'AI riscrive i testi; queste sostituzioni vengono comunque applicate per garantire che nessun dato dell'originale resti nel sito."
          : "Controlla i nuovi valori: vengono sostituiti in tutti i testi del sito (non nel codice)."}
      </p>
      <div className="mt-3 divide-y rounded-lg border">
        {rows.map((r, i) => (
          <div key={r.id} className="grid gap-2 p-2.5 sm:grid-cols-[auto_1fr_1fr] sm:items-center" data-testid={`dup-repl-row-${r.id}`}>
            <Checkbox checked={r.on} onCheckedChange={(v) => upd(i, { on: !!v })} aria-label={`Sostituisci ${r.value}`} data-testid={`dup-repl-on-${r.id}`} />
            <div className="min-w-0">
              <p className="text-[10px] uppercase tracking-wider text-slate-500">{r.label} · {r.count}×</p>
              <p className="text-sm text-slate-800 truncate" title={r.value}>{r.value}</p>
            </div>
            <Input value={r.new} disabled={!r.on} onChange={(e) => upd(i, { new: e.target.value })} className="h-8 text-sm" data-testid={`dup-repl-new-${r.id}`} />
          </div>
        ))}
        {!rows.length && <p className="p-3 text-sm text-slate-500">Nessun dato di contatto rilevato.</p>}
      </div>
      {!ai && (
        <div className="mt-4" data-testid="dup-custom-replacements">
          <p className="text-sm font-medium text-slate-900">Altri dati da sostituire</p>
          <div className="mt-2 space-y-2">
            {custom.map((c, i) => (
              <div key={i} className="flex gap-2">
                <Input value={c.old} onChange={(e) => setCustom(custom.map((x, j) => (j === i ? { ...x, old: e.target.value } : x)))} placeholder="Testo attuale" className="h-8 text-sm" data-testid={`dup-custom-old-${i}`} />
                <Input value={c.new} onChange={(e) => setCustom(custom.map((x, j) => (j === i ? { ...x, new: e.target.value } : x)))} placeholder="Nuovo testo" className="h-8 text-sm" data-testid={`dup-custom-new-${i}`} />
                <Button variant="ghost" size="icon" className="h-8 w-8 shrink-0" onClick={() => setCustom(custom.filter((_, j) => j !== i))} aria-label="Rimuovi"><X size={14} /></Button>
              </div>
            ))}
          </div>
          <Button variant="outline" size="sm" className="mt-2" onClick={() => setCustom([...custom, { old: "", new: "" }])} data-testid="dup-custom-add-btn"><Plus size={14} className="mr-1" />Aggiungi sostituzione</Button>
        </div>
      )}
    </div>
  );
}
